<template>
  <div>
    <v-snackbar
      v-model.trim="snackbar"
      :top="true"
      :color="color"
      :timeout="6000"
    >
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <div v-if="showdata == true">
      <v-card class="box1" flat>
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Student Health Card Form </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <br />

        <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="child_data.child_name"
              name="child_name"
              label="Name of the child"
              readonly
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="child_data.grade"
              name="grade"
              label="Grade"
              readonly
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="child_data.div"
              name="div"
              label="Division"
              readonly
              filled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <b
              >In case of emergency; if parent or guardian is not immediately
              available, contact:
            </b>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="emrg_name"
              name="emrg_name"
              label="Emergency Contact Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="emrg_contact"
              name="emrg_contact"
              label="Emergency Contact No"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="phy_name"
              name="phy_name"
              label="Family Physician's Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="phy_contact"
              name="phy_contact"
              label="Physician's Contact No"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="hosp_name"
              name="hosp_name"
              label="Hospital Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="hosp_contact"
              name="hosp_contact"
              label="Hospital Contact No"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" md="3">
            <!-- <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="bld_grp"
              name="bld_grp"
              label="Blood Group"
            ></v-text-field> -->
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="bld_grp"
              :items="bld_grp_list"
              item-text="bld_grp"
              item-value="id"
              label="Blood Group"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="child_data.dob"
              name="dob"
              label="Birth Date"
              readonly
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="child_data.height"
              name="height"
              label="Height"
              readonly
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="child_data.weight"
              name="weight"
              label="Weight"
              readonly
              filled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-btn
            class="button"
            @click="saveChildEmrgData()"
            >Save</v-btn
          >
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <v-icon color="error">mdi-asterisk</v-icon>
            <b>
              Please add a chronological account of chronic, recurrent, or
              significant acute illness or injury, including birth defects,
              surgical procedures, infections, etc.
            </b>
            <v-icon
              color="orange"
              size="35px"
              left
              title="Add Health Problems"
              @click="addHealthProblems()"
              >mdi-clipboard-plus-outline</v-icon
            >
          </v-col>
        </v-row>
        <br />
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <v-simple-table dense class="elevation-1">
              <thead>
                <tr>
                  <td>Sr. No</td>
                  <td>Date</td>
                  <td>Nature of Health Problem</td>
                  <td>Remarks</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i, index) in hprob_list" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ i.hprob_date }}</td>
                  <td>{{ i.nature_hprob }}</td>
                  <td>{{ i.remark }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <br />
        <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="medical_condition"
              name="medical_condition"
              label="My child has"
              persistent-hint
              hint="(Asthma/ hemophilia/ epilepsy, etc.)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              rounded
              outlined
              color="#0F2027"
              flat
              dense
              v-model="allergy"
              name="allergy"
              label="My child is allergic to"
              persistent-hint
              hint="(mention any foods/ medicines/ animals/ materials like chalk, sand, etc.)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <b
              >Please submit a photocopy of all medical tests and reports of any
              aliments that the child has had in the past.</b
            >
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <b style="text-transform: uppercase">Medicine administration:</b>
            <ul>
              <li>
                If a child requires any medicines to be administered during
                school hours, please send a written note for the same. No verbal
                communication will be entertained.
              </li>
              <li>
                The school shall take emergency measures in case an emergency
                situation arises out of an accident/ violent injury/ medical or
                surgical emergency with the understanding that the parent/
                guardian of the child shall be notified/ informed as soon as
                possible. The school shall not accept responsibility for making
                payments or reimbursing any expenses incurred or associated with
                the medical treatment.
              </li>
              <li>
                The parent does not hold the school responsible for any action
                of the school or its staff/ employees for any untoward incident
                and indemnifies the school of the same.
              </li>
              <li>
                <!-- <v-col cols="12" sm="12" md="12"> -->
                <v-checkbox
                  v-model="isvaccination"
                  label="The general vaccination of the child has been administered and
                  updated till date."
                ></v-checkbox>
                <!-- </v-col> -->
              </li>
              <li>
                <!-- <v-col cols="12" sm="12" md="12"> -->
                <v-checkbox
                  v-model="isverified"
                  :disabled="isverified ? true : false"
                  label="I hereby verify that I have read, understood and accepted the
                  statement above."
                ></v-checkbox>
                <!-- </v-col> -->
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-btn
            class="button"
            :disabled="!isverified ? true : false"
            @click="saveMedicalInfo()"
          >
            Save</v-btn
          >
        </v-row>
      </v-card>
      <v-dialog
        v-model="hprob_dialog"
        persistent
        scrollable
        max-width="1200px"
        transition="dialog-bottom-transition"
      >
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Add Student's Health Problems</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <br />
            <v-row dense justify="center">
              <v-col cols="12" sm="8" md="8">
                <p><b></b></p>
                <v-text-field
                  rounded
                  outlined
                  color="#0F2027"
                  flat
                  dense
                  v-model="hprob.nature_hprob"
                  name="nature_hprob"
                  label="Nature of Problem"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense justify="center">
              <v-col cols="12" sm="8" md="8">
                <p><b></b></p>
                <v-text-field
                  rounded
                  outlined
                  color="#0F2027"
                  flat
                  dense
                  v-model="hprob.remark"
                  name="remark"
                  label="Remark"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense justify="center">
              <v-col cols="12" sm="4" md="4">
                <!-- <p><b>Date</b></p> -->
                <v-text-field
                  outlined
                  dense
                  type="date"
                  v-model="hprob.hprob_date"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- <br /> -->
          <v-row justify="center">
            <v-btn
              class="button"
              absolute
              :disabled="
                hprob.nature_hprob.length > 0 &&
                hprob.remark.length > 0 &&
                hprob.hprob_date != null
                  ? false
                  : true
              "
              @click="saveHealthProblem()"
              >Add Health Problem</v-btn
            >
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="hprob_dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- -------------------------------------------------------- -->
    <div class="text-center" v-else>
      <v-card color="primary" dark>
        <v-card-text>
          {{ msg }}
          <v-progress-linear
            v-if="(msg = 'Please wait...')"
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: ["child_div_id"],
  data: () => ({
    loader: false,
    showdata: false,
    msg: "Please wait...",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    inst_health_card_data: [],
    academicyear: "",
    org_basic_data: [],
    child_data: [],
    health_data: [],
    medical_data: [],
    emrg_name: "",
    emrg_contact: "",
    phy_name: "",
    phy_contact: "",
    hosp_name: "",
    hosp_contact: "",
    bld_grp: "",
    hprob_dialog: false,
    hprob: {
      hprob_date: "",
      nature_hprob: "",
      remark: "",
    },
    hprob_list: [],
    bld_grp_list: [],
    // verify_flag:true,
    // vacination_flag:true,
    allergy: "",
    medical_condition: "",
    isvaccination: true,
    isverified: false,
    ay:""
  }),
  methods: {
    async initData() {
      this.showdata = false;
      const formdata = {
        child_div_id: this.child_div_id,
      };
      console.log("initdata", formdata);
      try {
        const res = await axios.post(
          "/healthCard/getChildHealthInfo",
          formdata
        );
        console.log("result", res);
        if (res.data.flag == "YES") {
          this.snackbar = true;
          this.showSnackbar("green", res.data.snackbar);
          this.child_data = res.data.child_data;
          this.allergy = res.data.allergy;
          this.medical_condition = res.data.medical_condition;
          this.isvaccination = res.data.isvaccination;
          this.isverified = res.data.isverified;
          this.emrg_name = res.data.emrg_name;
          this.emrg_contact = res.data.emrg_contact;
          this.phy_name = res.data.phy_name;
          this.phy_contact = res.data.phy_contact;
          this.hosp_name = res.data.hosp_name;
          this.hosp_contact = res.data.hosp_contact;
          this.bld_grp = res.data.bld_grp;
          this.showdata = true;
          this.bld_grp_list = res.data.bld_grp_list;
          this.hprob_list = res.data.hprob_list;
        } else {
           this.snackbar = true;
          this.showSnackbar("error", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.msg = "Cant fetch data!!!";
        }
        // this.other_info = false;
        //this.res = res
      } catch (err) {
        this.onerror(err);
        this.msg = "Cant fetch data!!!";
      } finally {
      }
    },
    print() {
      setTimeout(function () {
        window.print();
      }, 100);
    },
    addHealthProblems() {
      this.hprob_dialog = true;
    },
    async saveHealthProblem() {
      this.overlay = true;
      this.loader = true;
      const formdata = {
        child_div_id: this.child_div_id,
        hprob_date: this.hprob.hprob_date,
        nature_hprob: this.hprob.nature_hprob,
        remark: this.hprob.remark,
      };
      console.log("hprob", formdata);
      try {
        const res = await axios.post(
          "/healthCard/saveChildHealthProblem",
          formdata
        );
        console.log("result", res);
        if (res.data.flag == "YES") {
          this.showSnackbar("green", res.data.snackbar);
          this.hprob_list = res.data.hprob_list;
        } else {
          this.showSnackbar("error", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        // this.other_info = false;
        //this.res = res
      } catch (err) {
        this.onerror(err);
      } finally {
        this.hprob_dialog = false;
      }
    },
    saveChildInfo() {},
    async saveMedicalInfo() {
      console.log("child medical_info");
      console.log(this.allergy);
      console.log(this.medical_condition);
      const formdata = {
        allergy: this.allergy,
        medical_condition: this.medical_condition,
        isvaccination: this.isvaccination,
        isverified: this.isverified,
        child_div_id: this.child_div_id,
        ay: this.ay
      };
      try {
        const res = await axios.post("/healthCard/saveMedicalInfo", formdata);
        console.log("result", res);
        if (res.data.flag == "YES") {
          this.showSnackbar("green", res.data.snackbar);
        } else {
          this.showSnackbar("error", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        // this.other_info = false;
        //this.res = res
      } catch (err) {
        this.onerror(err);
      } finally {
      }
    },
    saveChildEmrgData() {
      this.snackbar = true;
      const emrg_info = {
        emrg_name: this.emrg_name,
        emrg_contact: this.emrg_contact,
        phy_name: this.phy_name,
        phy_contact: this.phy_contact,
        hosp_name: this.hosp_name,
        hosp_contact: this.hosp_contact,
        bld_grp: this.bld_grp,
        child_div_id: this.child_div_id,
      };
      console.log("child emrg_info", emrg_info);
      axios
        .post("/healthCard/saveChildEmrgData", emrg_info)
        .then((res) => {
          // alert(res.data.snackbar)
          if (res.data.flag == "YES") {
            this.showSnackbar("success", res.data.snackbar);
            this.overlay = false;
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
  },
  mounted() {
    // alert("mounted"+this.child_div_id)
    this.ay = localStorage.getItem("ay")
    this.child_div_id = localStorage.getItem("child_div_id");
    this.initData();
  },
};
</script>
<style scoped>
thead,
tr,
td {
  font-weight: bold !important;
  border: 1px solid black;
  font-size: large;
  text-align: center;
  /* height: 50px; */
}
.box1 {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
}
</style>
